// extracted by mini-css-extract-plugin
module.exports = {"flag":"styles_flag__1Mhzn","countrySelecter":"styles_countrySelecter__1oJ9Y","amountInput":"styles_amountInput__1JO0F"};